<template>
  <div>
    <div class="design-header">
      <span class="title">見出し</span>
    </div>
    <div class="text-box">
      <unit-text
        v-for="pageStyle in pageStyles"
        :key="pageStyle.selector"
        :target="'page'"
        :selector="pageStyle.selector"
        :styles="pageStyle.styles"
        :label="pageStyle.label"
        @updateStyles="updateContentStyles($event)"
      />
    </div>
    <div class="design-footer">
      <button
        class="close normal-btn"
        @click="closeButton"
        data-shortcut-esc="editorCloseButton"
      >
        閉じる
      </button>
    </div>
  </div>
</template>

<script>
import Base from '@/components/Content/Palette/ContentDesign/ContentDesignBase'
import ShortCutBase from '@/mixins/ShortCutBase'
import UnitText from '@/components/Content/Palette/ContentDesign/UnitText'

export default {
  name: 'content-design-page',
  mixins: [
    Base,
    ShortCutBase
  ],
  components: {
    UnitText
  },
  data () {
    return {
      pageStyles: {
        'h1': { selector: 'h1', styles: this.pageH1Styles, label: 'h1(見出し1)' },
        'h2': { selector: 'h2', styles: this.pageH2Styles, label: 'h2(見出し2)' },
        'h3': { selector: 'h3', styles: this.pageH3Styles, label: 'h3(見出し3)' },
        'h4': { selector: 'h4', styles: this.pageH4Styles, label: 'h4(見出し4)' },
      }
    }
  },
  computed: {
    pageH1Styles: {
      cache: false,
      get () {
        return this.$store.getters.findContentStyleAll('h1')
      }
    },
    pageH2Styles: {
      cache: false,
      get () {
        return this.$store.getters.findContentStyleAll('h2')
      }
    },
    pageH3Styles: {
      cache: false,
      get () {
        return this.$store.getters.findContentStyleAll('h3')
      }
    },
    pageH4Styles: {
      cache: false,
      get () {
        return this.$store.getters.findContentStyleAll('h4')
      }
    },
  },
  methods: {
    updateContentStyles (event) {
      this.$store.commit('updateContentStyles', {
        selector: event.selector,
        styles: event.styles
      })
    }
  },
  watch: {
    pageH1Styles (value) {
      this.pageStyles.h1.styles = value
    },
    pageH2Styles (value) {
      this.pageStyles.h2.styles = value
    },
    pageH3Styles (value) {
      this.pageStyles.h3.styles = value
    },
    pageH4Styles (value) {
      this.pageStyles.h4.styles = value
    },
  }
}
</script>

<style lang="scss" scoped>
.design-header, .design-footer {
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #dbdbdb;
  position: relative;
}
.design-header {
      border-top: 0.5px solid #dbdbdb;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  .btn {
    position: absolute;
    top: 10px;
    left: 20px;
    opacity: 0.5;
    font-size: 16px;
    margin: 0 !important;
    padding: 0 !important;
    background: none;
    border: none;
    color: $commonFontColor;
    transition: all 0.3s ease 0s;
    &::before {
      font-family: "Font Awesome 5 Free";
      content: '\f104';
      font-weight: 900;
      padding-right: 2px;
    }
    &:hover {
      opacity: 1;
    }
  }
  .title {
    color: $commonFontColor;
  }
}
.design-footer {
  vertical-align: bottom;
  border-top: #dbdbdb 1px solid;
  text-align: right;
  position: relative;
  .close {
    width: auto;
    display: block;
    font-size: 14px;
    border-radius: 5px;
    color: #fff;
    border: solid 1px #484848;
    background: #484848;
    opacity: 1;
    position: absolute;
    top: 6px;
    right: 8px;
    &:hover {
      background: #484848;
      opacity: 0.8;
    }
  }
}
.text-box {
  height: calc(100vh -  240px);
  overflow: auto;
}
</style>
